module.exports = __webpack_public_path__ + "static/img/ci-sery.e0e0017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/ci-sery.png
// module id = rtgt
// module chunks = 1